import { useContext } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import Text from '../../Text';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import { LOADING } from '../../../constants/localizations/app';
import PillButton from './PillButton';

const LoadingButton = ({ className, isDisabled }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <PillButton
      id="loadingButton"
      className={className}
      label={<Text name={getLocalizedText(LOADING)} />}
      onClick={noop}
      isDisabled={isDisabled}
    />
  );
};

LoadingButton.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default LoadingButton;
